import React from "react";
import SelectField from "./SelectField";
import { EMERGENCY_CONTACT_RELATIONSHIPS } from '@/constants/relationshipOptions';

interface AthleteRelationshipFieldProps {
  id: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  required?: boolean;
  error?: boolean | string;
  hint?: string;
  className?: string;
}

const AthleteRelationshipField: React.FC<AthleteRelationshipFieldProps> = ({
  id,
  name,
  value,
  onChange,
  label = "Relationship",
  placeholder = "Select relationship",
  required = false,
  error = false,
  hint,
  className = "",
}) => {
  return (
    <div className={className}>
      <SelectField
        id={id}
        name={name}
        label={label}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        error={error}
        hint={hint}
        options={EMERGENCY_CONTACT_RELATIONSHIPS}
      />
    </div>
  );
};

export default AthleteRelationshipField; 